import React from 'react';
export function OriginStory() {
  return <section className="py-20 bg-[#FDF8F4] px-4" data-id="element-177">
      <div className="max-w-3xl mx-auto text-center" data-id="element-178">
        <div className="w-20 h-20 bg-[#B8A9C9]/20 rounded-full flex items-center justify-center mx-auto mb-6 text-3xl" data-id="element-179">
          👩‍🦰
        </div>
        <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6" data-id="element-180">
          👩‍🦰 Quién creó Calma-5™
        </h2>
        <div className="prose prose-lg mx-auto text-gray-600" data-id="element-181">
          <p className="italic mb-6" data-id="element-182">
            "Fui esa mujer que lo intentó todo. La que luchó contra su mente. La
            que dormía agotada y despertaba igual."
          </p>
          <p className="mb-6" data-id="element-183">
            Hasta que una noche entendí algo simple:
            <br data-id="element-184" />
            <span className="font-bold text-gray-900 block mt-2 text-xl" data-id="element-185">
              "No necesito silencio. Necesito sentirme a salvo."
            </span>
          </p>
          <p data-id="element-186">
            Así nació Calma-5™. Desde la experiencia real. No desde la teoría.
          </p>
        </div>
      </div>
    </section>;
}